export { getVehiclesDataByCondition } from './get-vehicles-data-by-condition'
